import * as Yup from 'yup';

export const initialValues = {
  amount: '',
};

export const getValidationSchema = (maxAmount?: number) =>
  Yup.object().shape({
    amount: Yup.number()
      .required()
      .positive()
      // Less than the requested amount: the full amount is an Approve.
      .lessThan(
        Number(maxAmount ?? 0),
        'Must be less than the requested amount'
      ),
  });
